export const vibrate = (miliseconds) => {
  if ('vibrate' in navigator) {
    // const pattern = [];
    navigator.vibrate(miliseconds);
  }
};
